import React from 'react';

import { useTheme } from '../../context/Theme';
import AiIcon from '../AiIcon';

const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  return (
    <div className="theme-switcher" onClick={toggleTheme}>
      <div className={`theme-switcher-item ${isLight ? 'selected' : ''}`}>
        <AiIcon name="themelight" />
      </div>
      <div className={`theme-switcher-item ${!isLight ? 'selected' : ''}`}>
        <AiIcon name="themedark" />
      </div>
    </div>
  );
};

export default ThemeSwitcher;
